import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import is from '../utils/is';

// Import translations
import en from './translations/base';
import el from './translations/el';

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: {translations: en},
    el: {translations: el}
  },
  fallbackLng: 'en',
  debug: is.dev(),

  // Have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // We use content as keys
  nsSeparator: false,

  interpolation: {
    escapeValue: false, // Not needed for React
    formatSeparator: ','
  },

  react: {
    useSuspense: false
  },

  // Allows objects as valid translation result
  returnObjects: true
});

// Change `lang` property for root element
if (document.documentElement != null) {
  document.documentElement.lang = i18n.language;
}

export default i18n;
